export interface IRecentActivityResponse {
  swbcRefNum: number;
  firstName: string;
  lastName: string;
  vin: string;
  loanStatus: string;
  productSoldDate: string;
}

export interface IBorrowerInfo {
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  phoneNumber: string;
  emailAddress: string;
  dateOfBirth: string;
  accountNumber: string;
  loanNumber: string;
  referralCode: string;
  borrowerId: number;
}

export interface IPanelSummary {
  label: string;
  value: string;
}

export enum Steps {
  BorrowerInfo = 0,
  VehicleInfo,
  LoanCalc,
  Products = 3,
  PackageOptions = 3
}
export enum Forms {
  VehicleInfo = 'vehicleInformation',
  BorrowerInfo = 'borrowerInformation',
  LoanCalc = 'loanCalculator',
  Products = 'products',
  PackageOptions = 'packageOptions'
}
